import { observer } from 'mobx-react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import { ReferralsStore } from '../stores';
import { AutocompleteField, TextField } from '@roc/ui';
import { Option } from '@roc/ui/utils';
import React, { useEffect, useMemo } from 'react';
import { debounce } from '@roc/feature-utils';

export type AddReferrerProps = {
  store: ReferralsStore;
};
export const AddReferrer = observer(({ store }: AddReferrerProps) => {

  useEffect(() => {
    store.findBorrowersAndLeadsByNameDebounced(store.searchText)
  }, [store.searchText]);

  return (
    <Grid item container xs={12} spacing={4}>
      <Grid item container justifyContent="center" spacing={2}>
        <Grid item xs={6}>
          <AutocompleteField
            value={store.searchText}
            placeHolder={'Search...'}
            label={"Referrer's Name"}
            error={store.searchText.length === 0}
            helperText={store.searchText.length === 0 ? 'This field is required': null}
            onChange={newValue => {
              store.searchText = newValue;
            }}
            onSelect={(option: Option) => {
              store.searchText = option.label;
              store.fetchReferrerData(option.value, null);
            }}
            options={store.options}
          />
        </Grid>
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
          <TextField
            testId={'referrer-phone'}
            value={store.selectedReferrer?.cellPhone || store.selectedReferrer?.phone || ''}
            label={`Phone Number`}
            variant="outlined"
            standaloneLabel
            disabled
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            testId={'referrer-email'}
            value={store.selectedReferrer?.emailAddress || store.selectedReferrer?.email || ''}
            label={'Email'}
            variant="outlined"
            standaloneLabel
            disabled
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControlLabel
            control={
              <Checkbox
                required={true}
                checked={store.createBorrower}
                onChange={e => store.createBorrower = e.target.checked}
              />
            }
            label={"Please confirm that it’s okay to grant Portal access to the Referrer"}
          />
        </Grid>
      </Grid>
    </Grid>
  );
});
